<template>
  <v-icon
    v-if="status === 'GENERAL'"
    color="success"
  >
    {{ mdiCheck }}
  </v-icon>
  <v-icon
    v-else-if="status === 'LATE' || status === 'LEAVE_EARLY'"
    color="orange"
  >
    {{ mdiCheckboxBlankCircleOutline }}
  </v-icon>
  <v-icon
    v-else-if="status === 'ABSENT'"
    color="red"
  >
    {{ mdiMinus }}
  </v-icon>
</template>

<script>
import { mdiCheck, mdiCheckboxBlankCircleOutline, mdiMinus } from '@mdi/js'

export default {
  props: {
    status: {
      type: String,
      required: true
    }
  },
  data: () => ({
    mdiMinus: mdiMinus,
    mdiCheckboxBlankCircleOutline: mdiCheckboxBlankCircleOutline,
    mdiCheck: mdiCheck
  })
}
</script>
